import React, { useEffect } from 'react';
import cl from './Home.module.css';
import HomeInfo from './HomeInfo/HomeInfo';
import Product from '../Products/Product/Product';
import { animateScroll as scroll } from "react-scroll";

export const getRandomNumber = (min, max) => {
  return Math.round(min + Math.random() * (max - min));
};

const Home = (props) => {

useEffect(() => {
  scroll.scrollToTop();

}, [])


  let featuredProducts = (p) => {
    if (props.productsData.indexOf(p) < 6) {
      return (
        <Product
          key={getRandomNumber(1, 10000)}
          onAdd={props.onAdd}
          productId={p.productId}
          name={p.name}
          images={p.images}
          oldPrice={p.oldPrice}
          currency={p.currency}
          discount={p.discount}
          path={"products/" + p.path}
        />
      );
    }
  };

  let productElements = props.productsData.map((p) => featuredProducts(p));

  return (
    <section className={cl.app_about}>
      <HomeInfo
        shopName={props.aboutData.shopName}
        message={props.aboutData.message}
      />
      <div>
        {/* <h1 className={cl.about_title}>Featured Products</h1> */}
        <div className={cl.about_products}>{productElements}</div>
      </div>
      <div></div>
    </section>
  );
};

export default Home;
